import {
  Box,
  Button,
  FormControl,
  Paper,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../Homepage";
import InputField from "../../CommonComponents/InputField";
import SelectInputField from "../../CommonComponents/SelectInputField";
import { userAccessService } from "../../../Restclient/datacollection";
import { useSelector } from "react-redux";
import CustomCancelButton from "../../CommonComponents/CustomCancelButton";
import { Tooltip } from "@mui/material";
import DeleteIcon from "../../../images/LK_Delete";
import EditIcon from "../../../images/LK_Edit";
import EyeOpenIcon from "../../../images/LK_Eye_Open.png";
import Spinner from "../AdminDashboard/Spinner";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox";


function RoleManagement({selectedTreeNode, isReadOnly = false}) {
  const [roles, setRoles] = useState([]);
  const [modules, setModules] = useState([]);
  const [allmodules, setAllModules] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [rolesDialogOpen, setRolesDialogOpen] = useState(false);
  const { theme } = useContext(ThemeContext);
  const [newRoleDialogOpen, setNewRoleDialogOpen] = useState(false);
  const [newModuleDialogOpen, setNewModuleDialogOpen] = useState(false);
  const [newRole, setNewRole] = useState({
    Name: "",
    Description: "",
    Permissions: [],
    isSystemDefined: false,
  });
  const [newModule, setNewModule] = useState({
    Name: "",
    PermissionName: "",
    Description: "",
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const { User_Role_ID, Organizationid, Projectlist } = useSelector((state) => state.logindata.userdetails);
  const [editModule, setEditModule] = useState({
    id: "",
    GeneralName: "",
    PermissionName: "",
    Description: "",
  });
  const [deleteModule, setDeleteModule] = useState({
    id: "",
    GeneralName: "",
    PermissionName: "",
    Description: "",
  });
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [editModuleDialogOpen, setEditModuleDialogOpen] = useState(false);
  const [deleteModuleDialogOpen, setDeleteModuleDialogOpen] = useState(false);
  const [showRoles, setShowRoles] = useState(true);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const {PermissionsArray:usrPrmns} = useSelector((state) => state.logindata.userdetails);
  const [alertState, setAlertState] = useState({
    show: false,
    message: "",
    type: "success", 
  });

  // Helper function to check if user can perform role operations at current node level
  const canManageRolesAtCurrentLevel = () => {
    const userRoleName = userdetails?.User_Role_Details?.Name;
    const nodeType = selectedTreeNode?.Type?.toLowerCase();

    // EA_ADMIN (Level 1) can only manage roles at organization level
    if (userRoleName === "EA_ADMIN") {
      if (nodeType !== "organization") {
        return {
          allowed: false,
          message: "EA Admin can only create/edit/delete roles at Organization level."
        };
      }
    }

    // ORGANIZATION_ADMIN (Level 2) can only manage roles at sub-organization level
    if (userRoleName === "ORGANIZATION_ADMIN") {
      if (nodeType !== "sub-organization") {
        return {
          allowed: false,
          message: "Organization Admin can only create/edit/delete roles at Sub-Organization level."
        };
      }
    }

    // PROJECT_ADMIN (Level 4) can only manage roles at project level
    if (userRoleName === "PROJECT_ADMIN") {
      if (nodeType !== "project") {
        return {
          allowed: false,
          message: "Project Admin can only create/edit/delete roles at Project level."
        };
      }
    }

    return { allowed: true, message: "" };
  };

  const fetchUsersRoles = async () => {
    try {
            setIsLoading(true);
            let OrgID = (selectedTreeNode?.Type === "sub-organization" || selectedTreeNode?.Type === "organization") ? selectedTreeNode?.Organizationid : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.Organizationid :"All";
            let ProID = (selectedTreeNode?.Type === "sub-organization" || selectedTreeNode?.Type === "organization") ? "All" : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.ProjectId :"All";

      // if(userdetails?.User_Role_Details?.Name == "EA_ADMIN"){
      //     const allRoles = await userAccessService.getAllRolesByUserDetails(
      //       ((userdetails?.User_Role_Details?.Name == "EA_ADMIN") || (userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN")) ? "All": userdetails?.Projectlist[0],
      //       (userdetails?.User_Role_Details?.Name == "EA_ADMIN")? "All":Organizationid,User_Role_ID);

      //   setAllRoles(allRoles.data);

      //   const roles = await userAccessService.getRolesByUserDetails(
      //     userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
      //       userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
      //       ? "All"
      //       : userdetails?.Projectlist[0],
      //     userdetails?.User_Role_Details?.Name == "EA_ADMIN"
      //       ? "All"
      //       : Organizationid,
      //     User_Role_ID
      //   );
      
      //   setRoles(roles.data);
      // } else {
      //   const roles = await userAccessService.getRolesByUserDetails(
      //     userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
      //       userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
      //       ? "All"
      //       : userdetails?.Projectlist[0],
      //     userdetails?.User_Role_Details?.Name == "EA_ADMIN"
      //       ? "All"
      //       : Organizationid,
      //     User_Role_ID
      //   );
        
      //   setRoles(roles.data);
      // }

      const isEAAdmin = userdetails?.User_Role_Details?.Name === "EA_ADMIN";
      const isOrgAdmin = userdetails?.User_Role_Details?.Name === "ORGANIZATION_ADMIN";
      const projectId = (isEAAdmin || isOrgAdmin) ? "All" : userdetails?.Projectlist[0];
      const orgId = isEAAdmin ? "All" : Organizationid;

      if (isEAAdmin) {
        const allRoles = await userAccessService.getAllRolesByUserDetails(ProID, OrgID, User_Role_ID);
        setAllRoles(allRoles.data);
      }

      const roles = await userAccessService.getRolesByUserDetails(ProID, OrgID, User_Role_ID);
      setRoles(roles.data);

    } catch (err) {
      //console.error("Error fetching roles:", err);
    }
    setIsLoading(false);
  };

  const fetchModules = async () => {
    try {
      setIsLoading(true);
      const modulesLst = await userAccessService.getModulesByUserDetails(User_Role_ID);
      
      if (modulesLst.status == "success") {
        setModules(modulesLst.data);
      } else {
        setModules([]);
      }
    } catch (err) {
      //console.error("Error fetching modules:", err);
    }
    setIsLoading(false);
  };

  const fetchAllModules = async () => {
    try {
      setIsLoading(true);
      const modulesLst = await userAccessService.getAllModules(User_Role_ID);
      if (modulesLst.status == "success") {
        setAllModules(modulesLst.data);
      } else {
        setAllModules([]);
      }
    } catch (err) {
      //console.error("Error fetching modules:", err);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUsersRoles();
    fetchModules();
    fetchAllModules();
  }, [selectedTreeNode]);

  const handlePermissionChange = (module) => {
    setPermissions((prev) =>
      prev.includes(module)
        ? prev.filter((perm) => perm !== module)
        : [...prev, module]
    );
  };

  const handleOpenRolesDialog = () => {
    setRolesDialogOpen(true);
  };

  const handleCloseRolesDialog = () => {
    setRolesDialogOpen(false);
  };

  const handleRoleChange = (event) => {
    const roleId = event.target.value;
    const role = roles.find((r) => r.id === roleId);
    setSelectedRole(role);
    setPermissions(role?.Permissions || []);
  };

  // Handlers for New Role Dialog
  const handleOpenNewRoleDialog = () => {
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      return;
    }
    setNewRoleDialogOpen(true);
    setErrors({});
  };
  const handleCloseNewRoleDialog = () => {
    setNewRole({ Name: "", Description: "", Permissions: [] }); // Reset new role data
    setErrors({}); // Clear errors
    setNewRoleDialogOpen(false); // Close dialog
  };

  // Handlers for New Module Dialog

  const handleSaveNewRole = async () => {
    // Check access control first
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      handleCloseNewRoleDialog();
      return;
    }

    const errors = {};

    // Validation logic
    if (!newRole.Name) {
      errors.Name = "Role Name is required.";
    }
    if (!newRole.Description) {
      errors.Description = "Role Description is required.";
    }

    if (newRole.Permissions.length === 0) {
      errors.Permissions = "Role Permission is required.";
    }

    // If there are validation errors, stop execution
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    let OrgID = (selectedTreeNode?.Type === "organization" || selectedTreeNode?.Type === "sub-organization") ? selectedTreeNode?.Organizationid : ((selectedTreeNode?.Type === "Project") ? selectedTreeNode.Organizationid :"All");
    let ProID = (selectedTreeNode?.Type === "organization" || selectedTreeNode?.Type === "sub-organization") ? "All" : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.ProjectId :"All";


    //OrganizationID and ProjectID -This enables EA_ADMIN to create org level and project level modules(Future scope - Not in use currently)
    const newRoleObj = {
      UserRoleID: "",
      RoleLevel: "LEVEL100",
      Name: newRole.Name,
      Type: newRole.isSystemDefined ? "System-Defined" : "User-Defined",
      Description: newRole.Description,
      Permissions: newRole.Permissions,
      OrganizationID:OrgID,
      ProjectID:ProID,
    };

    const finalObj = {
      createruserroleProjectID:ProID,
      createruserroleidOrganizationID:OrgID,
      createruserroleid: User_Role_ID,
      userroleobject: newRoleObj,
    };
    try {
      const res = await userAccessService.createUserRoles(finalObj);
      
      //let res;
      if (res?.data) {
        // setRoles((prevRoles) => [
        //   ...prevRoles,
        //   {
        //     id: res.data.id || Date.now().toString(),
        //     Name: res.data.Name || newRole.Name,
        //     Description: res.data.Description || newRole.Description,
        //     Type: "User-Defined",
        //     Permissions: res.data.Permissions || newRole.Permissions,
        //   },
        // ]);
        const isEAAdmin = userdetails?.User_Role_Details?.Name === "EA_ADMIN";
        const isOrgAdmin = userdetails?.User_Role_Details?.Name === "ORGANIZATION_ADMIN";

        setRoles(res.data);
        setAllRoles(res.data);
        setNewRole({ Name: "", Description: "", Permissions: [], isSystemDefined: false });
        setErrors({});
        handleCloseNewRoleDialog();
        // alert("Role created successfully!");

       setAlertState({
        show: true,
        message: "Role created successfully!",
        type: "Info",
        confirmText:"OK"
      });


      } else {
      setAlertState({
        show: true,
        message:"Failed to create the role. Please try again.",
        type: "Error",
        confirmText:"OK"
      });


        // alert("Failed to create the role. Please try again.");
      }
    } catch (error) {
    
      setAlertState({
        show: true,
        message:"An error occurred while creating the role.",
        type: "Error",
        confirmText:"OK"
      });
    }
  };

  const handleOpenNewModuleDialog = () => setNewModuleDialogOpen(true);
  const handleCloseNewModuleDialog = () => {
    setNewModule({ GeneralName: "", PermissionName: "", Description: "" }); // Reset new module data
    setErrors({}); // Clear errors
    setNewModuleDialogOpen(false); // Close dialog
  };

  const handleSaveNewModule = async () => {
    const errors = {};
    if (validateModuleData(newModule, setErrors)) {
      return; // Stop execution if there are validation errors
    }

    const newModuleObj = {
      userCreaterProjectID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
        userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
          ? "All"
          : userdetails?.Projectlist[0],
      userCreatorOrganizationID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN"
          ? "All"
          : Organizationid,
      userCreaterRoleID: User_Role_ID,
      userPermissions: {
        PermissionID: "",
        GeneralName: newModule.GeneralName,
        Description: newModule.Description,
        PermissionName: newModule.PermissionName,
        UserRoleAssociated: [],
        Type: "MODULE",
      },
    };

    try {
      const res = await userAccessService.createUserModule(newModuleObj);

      if (res?.data) {
        setModules((prevModules) => [
          ...prevModules,
          {
            id: res.data.id || Date.now().toString(),
            GeneralName: res.data.GeneralName || newModule.GeneralName,
            PermissionName: res.data.PermissionName || newModule.PermissionName,
            Description: res.data.Description || newModule.Description,
          },
        ]);

        setAllModules((prevModules) => [
          ...prevModules,
          {
            id: res.data.id || Date.now().toString(),
            GeneralName: res.data.GeneralName || newModule.GeneralName,
            PermissionName: res.data.PermissionName || newModule.PermissionName,
            Description: res.data.Description || newModule.Description,
          },
        ]);

        setNewModule({ GeneralName: "", PermissionName: "", Description: "" });
        setErrors({});
        handleCloseNewModuleDialog();
        
            setAlertState({
              show: true,
              message:"Module created successfully!",
              type: "Info",
              confirmText:"OK"
            });
      } else {

          setAlertState({
            show: true,
            message:"Failed to create the module. Please try again.",
            type: "Error",
            confirmText:"OK"
          })

      }
    } catch (error) {
       setAlertState({
            show: true,
            message: "An error occurred while creating the module.",
            type: "Error",
            confirmText:"OK"
          })

      // alert("An error occurred while creating the module.");
    }
  };

  const handleSaveChanges = async () => {
    // Check access control first
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      handleCloseDialog();
      return;
    }

    let updatedRole = {};

    let OrgID = (selectedTreeNode?.Type === "sub-organization") ? selectedTreeNode?.Organizationid : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.Organizationid :"All";
    let ProID = (selectedTreeNode?.Type === "sub-organization") ? "All" : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.ProjectId :"All";


    if (userdetails?.User_Role_Details?.Name == "EA_ADMIN") {
        updatedRole = allRoles.find((role) => role.id === selectedRole.id);
        updatedRole = {
          ...updatedRole,
        }
    } else {
        updatedRole = roles.find((role) => role.id === selectedRole.id);
        updatedRole = {
          ...updatedRole
        };
    }

   
    updatedRole.Permissions = [...permissions];
   

    const updatedRoleObj = {
      updateruserroleProjectID: ProID,
      updateruserroleidOrganizationID: OrgID,
      updateruserroleid: User_Role_ID,
      userroleobject: updatedRole,
    };
 
    const rolesData = await userAccessService.updateUserRoles(updatedRoleObj);
    
    // Update the role's permissions
    // setRoles((prev) =>
    //   prev.map((role) =>
    //     role.id === selectedRole.id
    //       ? { ...role, Permissions: [...permissions] }
    //       : role
    //   )
    // );
    if(rolesData.success){
      setRoles(rolesData.data.data);
      setDialogOpen(false);
        setAlertState({
            show: true,
            message: "Permissions updated successfully!",
            type: "Info",
            confirmText:"OK"
          });
    }else{
      setDialogOpen(false);
        setAlertState({
            show: true,
            message: "Could not update permissions!",
            type: "Error",
            confirmText:"OK"
          });
    }

    
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleEditRole = (role) => {
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      return;
    }
   
    setSelectedRole(role);
    setPermissions(role.Permissions || []);
    setDialogOpen(true); 
  };

  const handleDeleteRole = (role) => {
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      return;
    }
    setSelectedRole(role);
    setDeleteDialogOpen(true); 
  };

  const handleConfirmDelete = async () => {
    // Check access control first
    const accessCheck = canManageRolesAtCurrentLevel();
    if (!accessCheck.allowed) {
      setAlertState({
        show: true,
        message: accessCheck.message,
        type: "Warning",
        confirmText: "OK"
      });
      setDeleteDialogOpen(false);
      return;
    }

    try {
      let OrgID = (selectedTreeNode?.Type === "sub-organization") ? selectedTreeNode?.Organizationid : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.Organizationid :"All";
      let ProID = (selectedTreeNode?.Type === "sub-organization") ? "All" : (selectedTreeNode?.Type === "Project") ? selectedTreeNode.ProjectId :"All";

      //  const selectedRole = roles.find((role) => role.id === selectedRole.id)
      const deleteRoleObj = {
        deleteruserroleid: User_Role_ID,
        deleteruserroleProjectID: ProID,
        deleteruserroleidOrganizationID: OrgID,
        userroleobject: selectedRole,
      };

      // Call API to delete the role
      const response = await userAccessService.deleteRole(deleteRoleObj);
      if (response.success) {
        // setRoles((prevRoles) =>
        //   prevRoles.filter((role) => role.id !== selectedRole.id)
        // );
        setRoles(response.data);
      
           setAlertState({
            show: true,
            message:"Role deleted successfully!",
            type: "Info",
            confirmText:"OK"
          });

      } else {
      
           setAlertState({
            show: true,
            message: response.message || "Failed to delete role.",
            type: "Error",
            confirmText:"OK"
          });
      }
    } catch (error) {
          setAlertState({
            show: true,
            message: "An error occurred while deleting the role.",
            type: "Error",
            confirmText:"OK"
          });
    } finally {
      setDeleteDialogOpen(false);
    }
  };

  const handleOpenEditModuleDialog = (module) => {
    setEditModule(module);
    setEditModuleDialogOpen(true);
  };

  const handleOpenDeleteModuleDialog = (module) => {
    setDeleteModule(module);
    setDeleteModuleDialogOpen(true);
  };

  const handleCloseEditModuleDialog = () => {
    setEditModule({
      id: "",
      GeneralName: "",
      PermissionName: "",
      Description: "",
    }); // Reset edit module data
    setErrors({});
    setEditModuleDialogOpen(false);
  };

  const handleCloseDeleteModuleDialog = () => {
    setDeleteModule({
      id: "",
      GeneralName: "",
      PermissionName: "",
      Description: "",
    }); // Reset edit module data
    setErrors({});
    setDeleteModuleDialogOpen(false);
  };

  const validateModuleData = (moduleData, setErrors) => {
    const errors = {};

    if (!moduleData.GeneralName || moduleData.GeneralName.trim() === "") {
      errors.GeneralName = "Module Name is required.";
    }

    if (!moduleData.PermissionName || moduleData.PermissionName.trim() === "") {
      errors.PermissionName = "Permission Name is required.";
    }

    if (!moduleData.Description || moduleData.Description.trim() === "") {
      errors.Description = "Description is required.";
    }

    setErrors(errors);
    return Object.keys(errors).length > 0; 
  };

  const handleSaveEditModule = async () => {
    if (!editModule || !editModule.id) {
        setAlertState({
            show: true,
            message: "No module selected for editing.",
            type: "Info",
            confirmText:"OK"
          });

    return;
  }

    const errors = {};
    if (validateModuleData(editModule, setErrors)) {
      return; 
    }

    const updatedModuleObj = {
      userCreaterProjectID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
        userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
          ? "All"
          : userdetails?.Projectlist[0],
      userCreatorOrganizationID:
        userdetails?.User_Role_Details?.Name == "EA_ADMIN"
          ? "All"
          : Organizationid,
      userCreaterRoleID: User_Role_ID,
      userPermissions: {
        id: editModule.id,
        PermissionID: editModule.PermissionID,
        GeneralName: editModule.GeneralName,
        Description: editModule.Description,
        PermissionName: editModule.PermissionName,
        Type: "User-Defined",
        UserRoleAssociated: editModule?.UserRoleAssociated,
      },
    };
  
    try {
      const response = await userAccessService.updateUserModule(
        updatedModuleObj
      );

      if (response?.data) {
        setModules((prevModules) =>
          prevModules.map((mod) =>
            mod.id === editModule.id
              ? {
                  ...mod,
                  GeneralName:
                    response.data.GeneralName || editModule.GeneralName,
                  PermissionName:
                    response.data.PermissionName || editModule.PermissionName,
                  Description:
                    response.data.Description || editModule.Description,
                }
              : mod
          )
        );

        setAllModules((prevModules) =>
          prevModules.map((mod) =>
            mod.id === editModule.id
              ? {
                  ...mod,
                  GeneralName:
                    response.data.GeneralName || editModule.GeneralName,
                  PermissionName:
                    response.data.PermissionName || editModule.PermissionName,
                  Description:
                    response.data.Description || editModule.Description,
                }
              : mod
          )
        );

        setErrors({});
        handleCloseEditModuleDialog();
       setAlertState({
            show: true,
            message: "Module updated successfully!",
            type: "Info",
            confirmText:"OK"
          });

      } else {
           setAlertState({
            show: true,
            message:"Failed to update the module.",
            type: "Error",
            confirmText:"OK"
          })
      }
    } catch (error) {
         setAlertState({
            show: true,
            message:"An error occurred while updating the module.",
            type: "Error",
            confirmText:"OK"
          })
    }
  };

  const handleSaveDeleteModule = async () => {

     if (!deleteModule || !deleteModule.id) {
        setAlertState({
            show: true,
            message:"No module selected for deletion.",
            type: "Info",
            confirmText:"OK"
          });
    return;
  }

    try{
      const newModuleObj = {
        userCreaterProjectID:
          userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
          userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
            ? "All"
            : userdetails?.Projectlist[0],
        userCreatorOrganizationID:
          userdetails?.User_Role_Details?.Name == "EA_ADMIN"
            ? "All"
            : Organizationid,
        userCreaterRoleID: User_Role_ID,
        userPermissions: {
          id: deleteModule.id,
          PermissionID: deleteModule?.PermissionID,
          GeneralName: deleteModule.GeneralName,
          Description: deleteModule.Description,
          PermissionName: deleteModule.PermissionName,
          UserRoleAssociated: [],
          Type: "MODULE",
        },
      };

      const response = await userAccessService.deleteUserModule(newModuleObj);
      if (response.success) {
        setModules((prevModules) =>
          prevModules.filter((module) => module.id !== deleteModule.id)
        );
        setAllModules((prevModules) =>
          prevModules.filter((module) => module.id !== deleteModule.id)
        );
           setAlertState({
            show: true,
            message:"Module deleted successfully!",
            type: "Info",
            confirmText:"OK"
          });
      } else {
           setAlertState({
            show: true,
            message:"Failed to delete Module.",
            type: "Error",
            confirmText:"OK"
          });
      }
    } catch (error) {
      
       setAlertState({
            show: true,
            message:"An error occurred while deleting the Module.",
            type: "Error",
            confirmText:"OK"
          });
    } finally {
      setDeleteModuleDialogOpen(false);
    }
  };

  return (
    <Box sx={{ padding: "20px" }}>
      {isLoading && <Spinner size="40px" color="blue" speed="0.8s" />}

      <Box
        sx={{
          display: "flex",
          gap: "16px",
          marginBottom: "20px",
          marginTop: "20px",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            marginBottom: "20px",
          }}
        >
          <Tabs
            value={showRoles ? 0 : 1}
            onChange={(e, newValue) => setShowRoles(newValue === 0)}
            aria-label="Roles and Modules Tabs"
            sx={{ minHeight: 35, borderBottom: "2px solid #e0e0e0" }}
          >
            {usrPrmns?.includes("USCR06") &&
              <Tab
                label="Roles"
                sx={{
                  minWidth: 125,
                  fontSize: "16px",

                  marginRight: "10px",
                  textTransform: "none",
                }}
                value={0}
              />
            } 
            {usrPrmns?.includes("USCR06") &&
              <Tab
                label="Permissions"
                sx={{
                  minWidth: 125,
                  fontSize: "16px",
                  textTransform: "none",
                }}
                value={1}
              />
             }
          </Tabs>
        </Box>
        <Box>
          {usrPrmns?.includes("USCR06") && !isReadOnly && (
            <button
              style={{
                width: "150px",
                height: "35px",
                fontSize: "18px",
                backgroundColor: "rgb(0, 92, 142)",
                color: "rgb(255, 255, 255)",
                cursor: "pointer",
                border: "none",
                borderRadius: "25px",
                marginRight: "10px",
              }}
              onClick={handleOpenNewRoleDialog}
            >
              Create Role
            </button>
          )}

          {usrPrmns?.includes("USCR06") && !isReadOnly && (
            <button
              style={{
                width: "200px",
                height: "35px",
                fontSize: "18px",
                backgroundColor: "rgb(0, 92, 142)",


                color: "rgb(255, 255, 255)",
                cursor: "pointer",
                border: "none",
                borderRadius: "25px",
              }}
              onClick={handleOpenNewModuleDialog}
            >
              Create Permission
            </button>
        )}
        </Box>
      </Box>

      {usrPrmns?.includes("USCR06") && showRoles &&
         (
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "none",
              marginTop: "20px",
              maxHeight: "500px", // Set the maximum height for the table
              overflowY: "auto",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "left",
                    }}
                  >
                    Role
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "left",
                    }}
                  >
                    Permissions
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "center",
                    }}
                  >
                    Type
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "center",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {roles?.length > 0 &&
                  userdetails?.User_Role_Details?.Name != "EA_ADMIN" &&
                  roles?.map((role) => (
                    <TableRow key={role.id}>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        <strong>{role.Name}</strong>
                        <br />
                        <small>
                          {role.Description || "No description available"}
                        </small>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {role.Permissions?.map((permission, index) => {
                          const moduleName =
                            allmodules.find(
                              (mod) => mod?.PermissionName === permission
                            )?.GeneralName || permission ;
                          return <div key={index}>{moduleName}</div>;
                        })}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        {role.Type || "User-Defined"}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        {role.OrganizationID != undefined &&
                        role.OrganizationID != "" && !isReadOnly ? (
                          <>
                            <Tooltip title="Edit" arrow>
                              <span
                                onClick={() => handleEditRole(role)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <EditIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>

                            <Tooltip title="Delete" arrow>
                              <span
                                onClick={() => handleDeleteRole(role)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <DeleteIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                          </>
                        ) : role.OrganizationID != undefined &&
                          role.OrganizationID != "" && isReadOnly ? (
                          "Read-Only (EA Admin on Project)"
                        ) : (
                          "System-Defined"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                {allRoles?.length > 0 &&
                  userdetails?.User_Role_Details?.Name == "EA_ADMIN" &&
                  allRoles?.map((role) => (
                    <TableRow key={role.id}>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        <strong>{role.Name}</strong>
                        <br />
                        <small>
                          {role.Description || "No description available"}
                        </small>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {role.Permissions?.map((permission, index) => {
                          const moduleName =
                            allmodules.find(
                              (mod) => mod?.PermissionName === permission
                            )?.GeneralName || permission;

                          return <div key={index}>{moduleName}</div>;
                        })}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        {role.Type || "User-Defined"}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        {!isReadOnly ? (
                          <>
                            <Tooltip title="Edit" arrow>
                              <span
                                onClick={() => handleEditRole(role)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <EditIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>

                            <Tooltip title="Delete" arrow>
                              <span
                                onClick={() => handleDeleteRole(role)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <DeleteIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          "Read-Only (EA Admin on Project)"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      {!showRoles  &&  usrPrmns?.includes("USCR06") &&
          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "none",
              marginTop: "20px",
              maxHeight: "500px",
              overflowY: "auto",
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "left",
                    }}
                  >
                    Module Name
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "left",
                    }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "16px",
                      fontWeight: 700,
                      lineHeight: "19px",
                      textAlign: "center",
                    }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                 {allmodules?.length > 0 &&
                 userdetails?.User_Role_Details?.Name != "EA_ADMIN" &&
                  allmodules?.map((module) => (
                    <TableRow key={module.id}>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {module.GeneralName}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {module.Description}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        {!isReadOnly ? (
                          <>
                            <Tooltip title="Edit Module" arrow>
                              <span
                                onClick={() => handleOpenEditModuleDialog(module)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <EditIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                            <Tooltip title="Delete" arrow>
                              <span
                                onClick={() => handleOpenDeleteModuleDialog(module)}
                                style={{
                                  marginRight: "2px",
                                  padding: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                <DeleteIcon
                                  color="var(--LK_BrandBlue)"
                                  width={"18px"}
                                  height={"18px"}
                                />
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          "Read-Only"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                {allmodules?.length > 0 &&
                  userdetails?.User_Role_Details?.Name == "EA_ADMIN" &&
                  allmodules?.map((module) => (
                    <TableRow key={module.id}>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {module.GeneralName}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        {module.Description}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "19px",
                          textAlign: "center",
                        }}
                      >
                        <Tooltip title="Edit Module" arrow>
                          <span
                            onClick={() => handleOpenEditModuleDialog(module)}
                            style={{
                              marginRight: "2px",
                              padding: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <EditIcon
                              color="var(--LK_BrandBlue)"
                              width={"18px"}
                              height={"18px"}
                            />
                          </span>
                        </Tooltip>
                        <Tooltip title="Delete" arrow>
                          <span
                            onClick={() => handleOpenDeleteModuleDialog(module)}
                            style={{
                              marginRight: "2px",
                              padding: "4px",
                              cursor: "pointer",
                            }}
                          >
                            <DeleteIcon
                              color="var(--LK_BrandBlue)"
                              width={"18px"}
                              height={"18px"}
                            />
                          </span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        }

      {selectedRole && (
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          PaperProps={{
            style: {
              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
              backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
              boxShadow: "none",
              overflowY: "scroll",
              scrollbarWidth: "thin",
              minWidth: "600px",
              maxWidth: "800px",
            },
          }}
        >
          <DialogTitle
            sx={{
              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
              backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
              color: "#3c3c3c",
              fontWeight: "700",
              fontSize: "24px",
              padding: "16px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                marginBottom: "16px",
                fontWeight: "bold",
                color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
              }}
            >
              {selectedRole.Name} Permissions
            </Typography>
          </DialogTitle>
          <DialogContent
            sx={{
              backgroundColor: "#ffffff",
              color: "#3c3c3c",
              padding: "24px",
              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
              backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            }}
          >
            <Box>
              <TableContainer
                component={Paper}
                sx={{
                  boxShadow: "none",
                  color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                  backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                }}
              >
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontWeight: 700,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        Module
                      </TableCell>
                      <TableCell
                        sx={{
                          color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                          backgroundColor:
                            theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                          fontFamily: "Roboto",
                          fontSize: "16px",
                          fontWeight: 700,
                          lineHeight: "19px",
                          textAlign: "left",
                        }}
                      >
                        Permission
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    
                    {modules?.length > 0 && selectedRole.Type != "System-Defined" &&
                      
                      modules?.map((module) => (
                        <TableRow key={module.id}>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            {module.GeneralName}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={permissions.includes(
                                module.PermissionName
                              )}
                              onChange={() =>
                                handlePermissionChange(module.PermissionName)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}

                      {allmodules?.length > 0 && selectedRole.Type === "System-Defined" &&
                      
                      allmodules?.map((module) => (
                        <TableRow key={module.id}>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            {module.GeneralName}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={permissions.includes(
                                module.PermissionName
                              )}
                              onChange={() =>
                                handlePermissionChange(module.PermissionName)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    {/*allmodules?.length > 0 &&
                      userdetails?.User_Role_Details?.Name == "EA_ADMIN" &&
                      allmodules?.map((module) => (
                        <TableRow key={module.id}>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            {module.GeneralName}
                          </TableCell>
                          <TableCell
                            sx={{
                              color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                              backgroundColor:
                                theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                              fontFamily: "Roboto",
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "19px",
                              textAlign: "left",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={permissions.includes(
                                module.PermissionName
                              )}
                              onChange={() =>
                                handlePermissionChange(module.PermissionName)
                              }
                            />
                          </TableCell>
                        </TableRow>
                      ))*/}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {/* <Button
                  onClick={handleCloseDialog}
                  variant="outlined"
                  color="primary"
                  sx={{
                    marginTop: "16px",
                    marginRight: "8px",
                    textTransform: "none",
                    borderRadius: "25px",
                    padding: "8px 16px",
                  }}
                >
                  Close
                </Button> */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveChanges}
                  sx={{
                    marginRight: "8px",
                    width: "125px",
                    height: "35px",
                    fontSize: "18px",
                    backgroundColor: "rgb(0, 92, 142)",
                    color: "rgb(255, 255, 255)",
                    cursor: "pointer",
                    border: "none",
                    borderRadius: "25px",
                  }}
                >
                  Save
                </Button>
                {/*<CustomCancelButton width={"125px"} onClick={handleCloseDialog}>
                  Close
                </CustomCancelButton>*/}
                <CustomCancelButton
                  buttonText={"Close"}
                  onClick={handleCloseDialog}
                  width={"125px"}
                />
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      <Dialog
        open={rolesDialogOpen}
        onClose={handleCloseRolesDialog}
        PaperProps={{
          style: {
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            boxShadow: "none",
            // overflowY: "scroll",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: "800px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // backgroundColor: "#ffffff",
            // color: "#3c3c3c",
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            fontWeight: "700",
            fontSize: "24px",
            padding: "16px",
          }}
        >
          All Roles and Permissions
          {/*<CustomCancelButton width={"125px"} onClick={handleCloseRolesDialog}>
            Close
          </CustomCancelButton> */}
          <CustomCancelButton
            buttonText={"Close"}
            onClick={handleCloseRolesDialog}
            width={"125px"}
          />
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: "#ffffff",
            color: "#3c3c3c",
            padding: "24px",
            color: theme === "dark" ? "#C1C1C1" : "#3A4452", // Dynamic text color
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
          }}
        >
          <RolePermissionsViewer roles={roles} modules={modules} />
        </DialogContent>
      </Dialog>

      <Dialog
        PaperProps={{
          style: {
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            boxShadow: "none",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: "600px",
          },
        }}
        open={newRoleDialogOpen}
        onClose={handleCloseNewRoleDialog}
      >
        <DialogTitle>Create New Role</DialogTitle>
        <DialogContent>
          {/* <InputField
            label="Role Name"
            required
            value={newRole.Name}
            onChange={(e) => setNewRole({ ...newRole, Name: e.target.value })}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          <InputField
            label="Role Description"
            required
            value={newRole.Description}
            onChange={(e) =>
              setNewRole({ ...newRole, Description: e.target.value })
            }
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />

          <SelectInputField
            multiple={true}
            label="Permissions"
            required={false}
            value={newRole.Permissions}
            onChange={(e) =>
              setNewRole({ ...newRole, Permissions: e.target.value })
            }
            options={modules.map((module) => ({
              value: module.PermissionName,
              label: module.PermissionName,
            }))}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          /> */}

          <InputField
            label="Role Name"
            required
            value={newRole.Name}
            onChange={(e) => {
              setNewRole({ ...newRole, Name: e.target.value });
              if (errors.Name) {
                setErrors((prev) => ({ ...prev, Name: "" })); // Clear error when user starts typing
              }
            }}
            error={!!errors.Name} // Display error state
            helperText={errors.Name} // Display error message
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />

          <InputField
            label="Role Description"
            required
            value={newRole.Description}
            onChange={(e) => {
              setNewRole({ ...newRole, Description: e.target.value });
              if (errors.Description) {
                setErrors((prev) => ({ ...prev, Description: "" })); // Clear error when user starts typing
              }
            }}
            error={!!errors.Description} // Display error state
            helperText={errors.Description} // Display error message
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />

          <SelectInputField
            multiple={true}
            label="Permissions"
            required={false}
            value={newRole.Permissions}
            onChange={(e) => {
              setNewRole({ ...newRole, Permissions: e.target.value });
              if (errors.Permissions) {
                setErrors((prev) => ({ ...prev, Permissions: "" })); // Clear error when user starts selecting
              }
            }}
            error={!!errors.Permissions} // Display error state
            helperText={errors.Permissions} // Display error message
            options={newRole.isSystemDefined ? allmodules.map((module) => ({
              value: module.PermissionName,
              label: module.GeneralName,
            })) :modules.map((module) => ({
              value: module.PermissionName,
              label: module.GeneralName,
            }))}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          
          {userdetails?.User_Role_Details?.Name === "EA_ADMIN" && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={newRole.isSystemDefined}
                  onChange={(e) =>
                    setNewRole({ ...newRole, isSystemDefined: e.target.checked })
                  }
                  sx={{
                    color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                    '&.Mui-checked': {
                      color: "rgb(0, 92, 142)",
                    },
                  }}
                />
              }
              label="System Defined"
              sx={{
                color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
                marginTop: "16px",
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          {/*<CustomCancelButton
            width={"125px"}
            onClick={handleCloseNewRoleDialog}
          >
            Cancel
          </CustomCancelButton>
            */}
          <CustomCancelButton
            buttonText={"Cancel"}
            onClick={handleCloseNewRoleDialog}
            width={"125px"}
          />
          <button
            style={{
              width: "125px",
              height: "35px",
              fontSize: "18px",
              backgroundColor: "rgb(0, 92, 142)",
              color: "rgb(255, 255, 255)",
              cursor: "pointer",
              border: "none",
              borderRadius: "25px",
            }}
            onClick={handleSaveNewRole}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        PaperProps={{
          style: {
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            boxShadow: "none",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: "800px",
          },
        }}
        open={newModuleDialogOpen}
        onClose={handleCloseNewModuleDialog}
      >
        <DialogTitle>Create New Module</DialogTitle>
        <DialogContent>
          <InputField
            label="Module Name"
            required
            value={newModule.GeneralName}
            onChange={(e) => {
              setNewModule({ ...newModule, GeneralName: e.target.value });
              if (errors.GeneralName) {
                setErrors((prev) => ({ ...prev, GeneralName: "" }));
              }
            }}
            error={!!errors.GeneralName}
            helperText={errors.GeneralName}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          <InputField
            label="Permission Name"
            required
            value={newModule.PermissionName}
            onChange={(e) => {
              setNewModule({ ...newModule, PermissionName: e.target.value });
              if (errors.PermissionName) {
                setErrors((prev) => ({ ...prev, PermissionName: "" }));
              }
            }}
            error={!!errors.PermissionName}
            helperText={errors.PermissionName}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          <InputField
            label="Module Description"
            required
            value={newModule.Description}
            onChange={(e) => {
              setNewModule({ ...newModule, Description: e.target.value });
              if (errors.Description) {
                setErrors((prev) => ({ ...prev, Description: "" }));
              }
            }}
            error={!!errors.Description}
            helperText={errors.Description}
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
        </DialogContent>
        <DialogActions>
          {/*<CustomCancelButton
            width={"125px"}
            onClick={handleCloseNewModuleDialog}
          >
            Cancel
          </CustomCancelButton> */}
          <CustomCancelButton
            buttonText={"Cancel"}
            onClick={handleCloseNewModuleDialog}
            width={"125px"}
          />
          <button
            style={{
              width: "125px",
              height: "35px",
              fontSize: "18px",
              backgroundColor: "rgb(0, 92, 142)",
              color: "rgb(255, 255, 255)",
              cursor: "pointer",
              border: "none",
              borderRadius: "25px",
            }}
            onClick={handleSaveNewModule}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        PaperProps={{
          style: {
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            boxShadow: "none",
            overflowY: "scroll",
            scrollbarWidth: "thin",
            minWidth: "480px",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            fontWeight: "700",
            fontSize: "24px",
          }}
        >
          Delete Role
        </DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            padding: "24px",
          }}
        >
          <Typography>
            Are you sure you want to delete the role{" "}
            <strong>{selectedRole?.Name}</strong>? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
          }}
        >
          {/*<CustomCancelButton onClick={() => setDeleteDialogOpen(false)}>
            Cancel
          </CustomCancelButton> */}
          <CustomCancelButton
            buttonText={"Cancel"}
            onClick={() => setDeleteDialogOpen(false)}
            width={"125px"}
          />
          <Button
            onClick={handleConfirmDelete}
            sx={{
              backgroundColor: "rgb(0, 92, 142)",
              color: "rgb(255, 255, 255)",
              borderRadius: "25px",
              padding: "8px 16px",
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editModuleDialogOpen}
        onClose={handleCloseEditModuleDialog}
        PaperProps={{
          style: {
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            boxShadow: "none",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle>Edit Module</DialogTitle>
        <DialogContent>
          {/* <InputField
            label="Module Name"
            required
            value={editModule.GeneralName}
            onChange={(e) =>
              setEditModule({ ...editModule, GeneralName: e.target.value })
            }
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          <InputField
            label="Permission Name"
            required
            value={editModule.PermissionName}
            onChange={(e) =>
              setEditModule({ ...editModule, PermissionName: e.target.value })
            }
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          />
          <InputField
            label="Module Description"
            required={false}
            value={editModule.Description}
            onChange={(e) =>
              setEditModule({ ...editModule, Description: e.target.value })
            }
            style={{
              color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
              width: "100%",
            }}
          /> */}
          <InputField
            label="Module Name"
            required
            value={editModule.GeneralName}
            onChange={(e) => {
              setEditModule({ ...editModule, GeneralName: e.target.value });
              if (errors.GeneralName) {
                setErrors((prev) => ({ ...prev, GeneralName: "" }));
              }
            }}
            disabled={true}
            error={!!errors.GeneralName}
            helperText={errors.GeneralName}
          />
          <InputField
            label="Permission Name"
            required
            value={editModule.PermissionName}
            onChange={(e) => {
              setEditModule({ ...editModule, PermissionName: e.target.value });
              if (errors.PermissionName) {
                setErrors((prev) => ({ ...prev, PermissionName: "" }));
              }
            }}
            disabled={true}
            error={!!errors.PermissionName}
            helperText={errors.PermissionName}
          />
          <InputField
            label="Module Description"
            required
            value={editModule.Description}
            onChange={(e) => {
              setEditModule({ ...editModule, Description: e.target.value });
              if (errors.Description) {
                setErrors((prev) => ({ ...prev, Description: "" }));
              }
            }}
            error={!!errors.Description}
            helperText={errors.Description}
          />
        </DialogContent>
        <DialogActions>
          {/* <CustomCancelButton
            width={"125px"}
            onClick={handleCloseEditModuleDialog}
          >
            Cancel
          </CustomCancelButton> */}
          <CustomCancelButton
            buttonText={"Cancel"}
            onClick={handleCloseEditModuleDialog}
            width={"125px"}
          />
          <button
            style={{
              width: "125px",
              height: "35px",
              fontSize: "18px",
              backgroundColor: "rgb(0, 92, 142)",
              color: "rgb(255, 255, 255)",
              cursor: "pointer",
              border: "none",
              borderRadius: "25px",
            }}
            onClick={handleSaveEditModule}
          >
            Save
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModuleDialogOpen}
        onClose={handleCloseDeleteModuleDialog}
        PaperProps={{
          style: {
            color: theme === "dark" ? "#C1C1C1" : "#3A4452",
            backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
            boxShadow: "none",
            scrollbarWidth: "thin",
            minWidth: "600px",
            maxWidth: "600px",
          },
        }}
      >
        <DialogTitle>Delete Module</DialogTitle>
        <DialogContent
          sx={{
            backgroundColor: theme === "dark" ? "#252525" : "#ffffff",
            color: theme === "dark" ? "#FFFFFF" : "#3c3c3c",
            padding: "24px",
          }}
        >
          <Typography>
            Are you sure you want to delete the module{" "}
            <strong>{deleteModule.PermissionName}</strong>? This action cannot
            be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          {/* <CustomCancelButton
            width={"125px"}
            onClick={handleCloseEditModuleDialog}
          >
            Cancel
          </CustomCancelButton> */}
          <CustomCancelButton
            buttonText={"Cancel"}
            onClick={handleCloseDeleteModuleDialog}
            width={"125px"}
          />
          <button
            style={{
              width: "125px",
              height: "35px",
              fontSize: "18px",
              backgroundColor: "rgb(0, 92, 142)",
              color: "rgb(255, 255, 255)",
              cursor: "pointer",
              border: "none",
              borderRadius: "25px",
            }}
            onClick={handleSaveDeleteModule}
          >
            Delete
          </button>
        </DialogActions>
      </Dialog>
           <CustomDialogBox
        dialogTitle={alertState.message}
        openDialog={alertState.show}
        handleConfirmDialog={() => setAlertState((prev) => ({ ...prev, show: false }))}
        confirmText={alertState.confirmText || "OK"}
        type={alertState.type}
      />
    </Box>
  );
}

function RolePermissionsViewer({ roles, modules }) {
  const theme = useContext(ThemeContext).theme;
  const {PermissionsArray:usrPrmns} = useSelector((state) => state.logindata.userdetails);
  return (
    <Box
      sx={{
        color: theme === "dark" ? "#C1C1C1" : "#3A4452",
        backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
      }}
    >
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
            {usrPrmns?.includes("USCR06") && 
            <TableCell
                sx={{
                  color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                  backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontWeight: 700,
                  lineHeight: "19px",
                  textAlign: "left",
                }}
              >
                Role
              </TableCell>
            }
              <TableCell
                sx={{
                  color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                  backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                  fontFamily: "Roboto",
                  fontSize: "16px",
                  fontWeight: 700,
                  lineHeight: "19px",
                  textAlign: "left",
                }}
              >
                Module
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {roles?.map((role) =>
              role?.Permissions?.map((permission, index) => (
                <TableRow key={`${role.id}-${permission}-${index}`}>
                  {index === 0 && (
                    <TableCell
                      rowSpan={role.Permissions.length}
                      sx={{
                        color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                        backgroundColor:
                          theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "19px",
                        textAlign: "left",
                      }}
                    >
                      <strong>{role.Name}</strong>
                      <br />
                      <small>
                        {role.Description || "No description available"}
                      </small>
                    </TableCell>
                  )}
                  <TableCell
                    sx={{
                      color: theme === "dark" ? "#C1C1C1" : "#3A4452",
                      backgroundColor: theme === "dark" ? "#1E1E1E" : "#F0EFEF",
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: 400,
                      lineHeight: "19px",
                      textAlign: "left",
                    }}
                  >
                    {modules?.length > 0
                      ? modules.find((mod) => mod.PermissionName === permission)
                          ?.Name || permission
                      : "No Module Assigned"}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default RoleManagement;